import { render, staticRenderFns } from "./SettingsPrivacyPolicy.vue?vue&type=template&id=fd7ebc70"
import script from "./SettingsPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./SettingsPrivacyPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports